const CDN_URL = 'https://cdn.machool.com/shared/images/couriers';

export function getAirCanadaImageByServiceName(serviceName: string): string | null {
  const n = (serviceName || '').toUpperCase();

  if (n.includes('CANADA POST'))     return 'ac_cp';
  if (n.match(/INTELCOM|IC/))        return 'ac_ic_dragonfly';
  if (n.includes('UNIUNI'))          return 'ac_un';
  if (n.includes('TFORCE'))          return 'ac_tf';
  if (n.includes('APPLE'))           return 'ac_ae';
  if (n.includes('TREXITY'))         return 'ac_tx';
  if (n.includes('SPRING'))          return 'ac_sp';

  return null;
}

// FedEx logic
function getFedExSlug(serviceName: string): string | null {
  const name = (serviceName || '').toLowerCase();
  
  if (name.includes('fedex') && name.includes('ground')) {
    return 'fedex-ground';
  } 
  
  if (name.includes('fedex') && 
     (name.includes('express') || 
      name.includes('overnight') || 
      name.includes('economy') || 
      name.includes('2day'))) {
    return 'fedex-express';
  }
  
  return null;
}

// Square logo - services
export function getLogo(rate: {
    provider: string;
    serviceName: string;
    serviceCode?: string;
  }): string {
    let slug = (rate.provider || '').toLowerCase();
    const name = (rate.serviceName || '').toLowerCase();
  
    // FedEx special cases
    const fedExSlug = getFedExSlug(rate.serviceName);
    if (fedExSlug) {
      slug = fedExSlug;
    // Rivo
    } else if (slug === 'rivo') {
      if (
        (rate.serviceCode || '').toUpperCase().includes('AC') ||
        (rate.serviceName || '').toUpperCase().includes('MULTI')
      ) {
        const serviceIdentifier = rate.serviceCode || rate.serviceName || '';
        slug = getAirCanadaImageByServiceName(serviceIdentifier) || serviceIdentifier.toLowerCase();
      } else {
        slug = (rate.serviceCode || '').toLowerCase();
      }
    } else if (slug === 'aircanadadomestic' || slug === 'aircanadainternational') {
      slug = 'ac';
    }
  
    return `${CDN_URL}/${slug}-square.svg`;
}

// Full logo - summary page
export function getFullLogo(rate: {
  provider: string;
  serviceName: string;
  serviceCode?: string;
}): string | null {
  let slug = (rate.provider || '').toLowerCase();
  const name = (rate.serviceName || '').toLowerCase();

  // FedEx special cases
  const fedExSlug = getFedExSlug(rate.serviceName);
  if (fedExSlug) {
    slug = fedExSlug;
  // Rivo → Air-Canada rules
  } else if (slug === 'rivo') {
    if (
      (rate.serviceCode || '').toUpperCase().includes('AC') ||
      (rate.serviceName || '').toUpperCase().includes('MULTI')
    ) {
      const serviceIdentifier = rate.serviceCode || rate.serviceName || '';
      slug = getAirCanadaImageByServiceName(serviceIdentifier) || serviceIdentifier.toLowerCase();
    } else {
      slug = 'aircanada';
    }
  } else if (slug === 'aircanadadomestic' || slug === 'aircanadainternational') {
    slug = 'aircanada';
  }

  return `${CDN_URL}/${slug}.svg`;
}

// Arrows in service names
export function formatServiceName(name: string): string {
  // Replace ASCII arrow with Unicode arrow
  return name?.replace(/ -> /g, ' → ');
}